export default {
    column_visible:{
        quota_number:false,
    },
    subscriber:null,
    Watch_documument:false,
    edit_document:false,
    loading:true,
    loading_form:false,
    loading_transactions:false,
    loading_csv:false,
    loading_accounting_document:false,
    loading_create_transaction:false,
    loading_cancel_accounting_document:false,
    code_voucherType:null,
    selected_document:false,
    origin_document:false,
    modalAttach:{
        show : false,
        s_title_modal: null
    },
    cross_title:null,
    invoice:{
        branchOffice:null,
        vouchertype:null,
        consecutive:null,
    },
    selected_document_title: {
        id:null,
        in_progress:true
    },
    loading_totals:false,
    totals:{},
	params:{
        user:null,
        user_accounting_modification:null,
        document_date:null,
        accounting_date_last_modification:null,
        due_date:null,
        branchoffice_id : null,
        voucherType_id : null,
        template_id:null,
        num_doc:null,
        prefix:null,
        date:null,
        contact_id:null,
        center_cost:null,
        observation:null,
        city_id:null,
        projects_id:null,
        seller_id:null,
        invoice:null,
        document_id:null,
        user_id:null,
        order_account_select:null,
        affects_prefix_document:null,
        affects_number_document:null,
        affects_date_document:null,
        crossing_due_date_document:null,
        term_days_crossing:null,
        cancellation_reason:null,
        ref_update_doc:null,
        created_at:null,
        term_days: null,

        documents_products:[],
        files:[],
        document_transactions:[
            {
                id : 1,
                account_id : null,
                observation : '',
                contact_id : null,
                no_doc : null,
                value : 0,
                base_value : 0,
                order : 1,
                payment_method : null,
                projects_column_visible : null,
                contact_column_visible : null,
                cost_center_column_visible : null,
                base_value_column_visible : null,
                cross_date_visible:null,
                account_select : [],
                contact_select : [],
                affects_document : [],
                affects_prefix_document:null,
                commissionable_concept_id:null,
                crossing_number:null,
                crossing_date:null,
                manage_document:false,
                validation_no_doc:null,
                due_date:null,
                quota_number:null,

                account_code: null,
                account_name: null,
                bank_document_number: null,
                affects_prefix: null,
                affects_consecutive: null,
                affects_document_id: null,
                mode: 1,
                disabled_account_select: false


            }
        ],
        document_transaction:null,
        id_correria:null,
    },
    paramsVoucherType:{
        paginate : false,
        filter : null,
        branchoffice : null,
        id:null,
    },
    document_files_new:[],
    document_files_delete:[],
    paramsquery:{
        is_customer: false,
        is_provider: false,
        is_employee: false,
        filter_customer: [],
        filter_provider: [],
        filter_employee: [],
        paginate: true,
        page: 1,
        perPage: 50,
        query: '',
        sortBy: 'id',
        sort: 'ASC',
        only_active:true,
    },
    total_debit: 0,
    total_credit: 0,
    total_difference: 0,
    paramsquerydt:{
        is_customer: false,
        is_provider: false,
        is_employee: false,
        filter_customer: [],
        filter_provider: [],
        filter_employee: [],
        paginate: true,
        page: 1,
        perPage: 100,
        query: '',
        sortBy: 'id',
        sort: 'ASC',
        only_active:true,
    },
    paramstemplates:{
        perPage: 1000,
        sortBy: 'code',
        sort: 'ASC',
        paginate : true,
        filter : null,
    },
    model_code:null,
    model_accounting_generate:null,
    branchOffice:null,
    voucherTypes:[],
    branchOffices: [],
    groups:[],
    contacts:[],
    contactsdt:[],
    contactdt:[],
    templates:[],
    cost_center_1:[],
    cancellation_reasons:[],
    cities:[],
    sellers:[],
    projects:[],
    projectsdt:[],
    Concenpts:[],
    document_transactions:[],
    projects_column_visible:false,
    contact_column_visible:false,
    cost_center_column_visible:false,
    base_value_column_visible:false,
    payment_column_visible:false,
    manage_bank_document:false,
    manage_document:false,
    expiration:false,
    commissionable_concept:false,
    cross_date_visible:false,
    account_selects:[],
    account_select:[],
    payment_methods:[],
    files_search_document:[],
    commissionable_concepts:[],
    showInputs:{
        center_cost:true,
        seller:false,
        correrias:false,
        observation1:true,
        observation2:true,
        projects:true,
        cross_doc:true,
        cross_doc_date:true,
        files:true
    },
    validations_model:{
        cross_doc: false,
        cross_doc_date: false,
    },
    file_name :"",
    modal_alert: {show:false},
    old_document: {},
    show_pdf : false,
    pdf_document_name: null,
    pdf_clear_params: true,
    auditDocuments: [],
    contactsAudit: [],
    paramsDocument: [],
    validate_firm_date_account:false,
    correrias:[],
    balances_by_contacts: []
}



// WEBPACK FOOTER //
// ./src/modules/various-vouchers/state.js